import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/bg_less_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-512b2727"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "contact-section",
  id: "contact-section"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Let's talk", -1))
const _hoisted_3 = { class: "contact-methods-container" }
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<h3 class=\"form-title\" data-v-512b2727>I&#39;ll contact you soon</h3><label for=\"name\" data-v-512b2727>Your name</label><input type=\"text\" id=\"name\" placeholder=\"Complete name\" name=\"from_name\" data-v-512b2727><br data-v-512b2727><br data-v-512b2727><label for=\"email\" data-v-512b2727>Your email</label><input type=\"email\" id=\"email\" placeholder=\"someone@example.com\" name=\"from_email\" data-v-512b2727><br data-v-512b2727><br data-v-512b2727><label for=\"name\" data-v-512b2727>Your whatsapp (optional)</label><input type=\"text\" id=\"phone\" placeholder=\"+123 345 5678909\" name=\"from_phone\" data-v-512b2727><br data-v-512b2727><br data-v-512b2727><label for=\"message\" data-v-512b2727>Your message</label><textarea id=\"message\" cols=\"30\" rows=\"10\" name=\"message\" placeholder=\"Type something here (optional)\" data-v-512b2727></textarea><br data-v-512b2727><br data-v-512b2727><input type=\"submit\" value=\"Send!\" data-v-512b2727>", 18)
const _hoisted_23 = [
  _hoisted_5
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Logo",
    class: "logo"
  })
], -1))

import emailjs from '@emailjs/browser';
import { ref } from 'vue';

//* Defined.

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactSection',
  setup(__props) {

const form = ref<HTMLFormElement>();

//* Functions.
const sendEmail = () => {
  if (!form.value) return;
  emailjs.sendForm('service_yhqcs8h', 'template_37aqibf', form.value, 'mMtSc3MSYDiJ64l2v')
    .then((result) => {
        alert("Thanks you! <br/> I'll contact you as soon as possible");
    }, (error) => {
        console.log('FAILED...', error.text);
    }
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", {
        class: "contact-form",
        ref_key: "form",
        ref: form,
        onSubmit: _withModifiers(sendEmail, ["prevent"])
      }, _hoisted_23, 40, _hoisted_4),
      _hoisted_24
    ])
  ]))
}
}

})